webpackJsonp([9393494642403],{

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(23);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Constants = __webpack_require__(71);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _wideangle = __webpack_require__(303);
	
	var _wideangle2 = _interopRequireDefault(_wideangle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BannerWrapper = _styledComponents2.default.div.withConfig({
	    displayName: 'tour-banner__BannerWrapper'
	})(['margin:0 ', '%;position:relative;'], _Constants2.default.MAIN_PADDING);
	
	var Banner = _styledComponents2.default.div.withConfig({
	    displayName: 'tour-banner__Banner'
	})(['height:50vh;background-image:url(', ');background-size:cover;max-height:400px;'], _wideangle2.default);
	
	var Overlay = _styledComponents2.default.div.withConfig({
	    displayName: 'tour-banner__Overlay'
	})(['position:absolute;height:100%;top:0;left:0;right:0;background-color:rgba(0,0,0,0.7);z-index:5;display:flex;justify-content:center;align-items:center;color:white;']);
	
	var TourPageBanner = function TourPageBanner() {
	    return _react2.default.createElement(
	        BannerWrapper,
	        null,
	        _react2.default.createElement(Banner, null),
	        _react2.default.createElement(
	            Overlay,
	            null,
	            _react2.default.createElement(
	                'h1',
	                null,
	                'Tour'
	            )
	        )
	    );
	};
	
	exports.default = TourPageBanner;
	module.exports = exports['default'];

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(23);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Constants = __webpack_require__(71);
	
	var _Constants2 = _interopRequireDefault(_Constants);
	
	var _tourBanner = __webpack_require__(510);
	
	var _tourBanner2 = _interopRequireDefault(_tourBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'tour__ListWrapper'
	})(['margin:2rem ', '%;position:relative;text-align:center;a{font-size:3rem;}p{padding-left:2%;}'], _Constants2.default.MAIN_PADDING);
	var ListSubHead = _styledComponents2.default.div.withConfig({
	  displayName: 'tour__ListSubHead'
	})(['margin:2rem ', '%;position:relative;font-size:3rem;font-weight:700;text-decoration:underline solid rgb(244,131,66);text-align:center;'], _Constants2.default.MAIN_PADDING);
	
	var TourPage = function TourPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_tourBanner2.default, null),
	    _react2.default.createElement(
	      'h1',
	      { className: 'showTime' },
	      'Upcoming Shows'
	    ),
	    _react2.default.createElement(
	      ListWrapper,
	      null,
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement('hr', null),
	      data.allMarkdownRemark.edges.map(function (showPost) {
	        return _react2.default.createElement(
	          'a',
	          { href: showPost.node.frontmatter.path },
	          _react2.default.createElement(
	            'div',
	            { className: 'tour-entry', key: showPost.node.frontmatter.title },
	            _react2.default.createElement(
	              'div',
	              { className: 'leftAlign' },
	              showPost.node.frontmatter.title,
	              _react2.default.createElement(
	                'div',
	                { className: 'locationClass' },
	                showPost.node.frontmatter.time != '' ? '@ ' + showPost.node.frontmatter.time : '@ tbd',
	                showPost.node.frontmatter.location == null ? ': private show' : ': ' + showPost.node.frontmatter.location
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              new Date(showPost.node.frontmatter.date).toDateString()
	            )
	          )
	        );
	      }),
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement('hr', null)
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = TourPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tour-jsx-35d6e6a88ba98adee2e3.js